import { useCallback } from "react";
import { authService } from "@/services/authService";

export const useUserActions = () => {
  const logout = useCallback(async () => {
    try {
      await authService.signOut();
    } catch (error) {
      console.error("Error during logout:", error);
    }
  }, []);

  const deleteAccount = useCallback(async (text: string) => {
    try {
      if (text.toLowerCase().trim() === "удалить") {
        await authService.deleteAccount();
      }
    } catch (error) {
      console.error("Error deleting account:", error);
    }
  }, []);

  return {
    logout,
    deleteAccount,
  };
}; 